import { IHeroSection } from "components/BrandPrinciplesHero/BrandPrinciplesHero.types";
import { IOverviewHeroSlide } from "pages/LayoutComponents/OverviewHero/OverviewHero.types";

import wifi1Mp4 from "./assets/hero/wifi-1.mp4";
import wifi1Jpg from "./assets/hero/wifi-1.jpg";
import wifi2Mp4 from "./assets/hero/wifi-2.mp4";
import wifi2Jpg from "./assets/hero/wifi-2.jpg";
import wifi3Mp4 from "./assets/hero/wifi-3.mp4";
import wifi3Jpg from "./assets/hero/wifi-3.jpg";
import wifi4Mp4 from "./assets/hero/wifi-4.mp4";
import wifi4Jpg from "./assets/hero/wifi-4.jpg";

import dedicatedSpectralRadioMp4 from "./assets/screens/dedicated-spectral-radio.mp4";
import dedicatedSpectralRadioJpg from "./assets/screens/dedicated-spectral-radio.jpg";
import powerfulChannelPlanningMp4 from "./assets/screens/powerful-channel-planning.mp4";
import powerfulChannelPlanningJpg from "./assets/screens/powerful-channel-planning.jpg";
import rfEnvironmentScanningMp4 from "./assets/screens/rf-environment-scanning.mp4";
import rfEnvironmentScanningJpg from "./assets/screens/rf-environment-scanning.jpg";
import flexibleAuthMethodsMp4 from "./assets/screens/flexible-auth-methods.mp4";
import flexibleAuthMethodsJpg from "./assets/screens/flexible-auth-methods.jpg";
import wifiCentralizedRemoteManagementMp4 from "./assets/screens/wifi-centralized-remote-management.mp4";
import wifiCentralizedRemoteManagementJpg from "./assets/screens/wifi-centralized-remote-management.jpg";
import apAnalyzerMp4 from "./assets/screens/ap-analyzer.mp4";
import apAnalyzerJpg from "./assets/screens/ap-analyzer.jpg";

export const BRAND_PRINCIPLES_HERO_SLIDES = [
  {
    id: 0,
    label: "wifi.overview.brandPrinciples.1.title",
    src: wifi1Mp4,
    poster: wifi1Jpg,
  },
  {
    id: 1,
    label: "wifi.overview.brandPrinciples.2.title",
    src: wifi2Mp4,
    poster: wifi2Jpg,
  },
  {
    id: 2,
    label: "wifi.overview.brandPrinciples.3.title",
    src: wifi3Mp4,
    poster: wifi3Jpg,
  },
  {
    id: 3,
    label: "wifi.overview.brandPrinciples.4.title",
    src: wifi4Mp4,
    poster: wifi4Jpg,
  },
] satisfies Array<IHeroSection>;

export const PRO_SCREEN_OVERVIEW_SLIDES = [
  {
    id: 0,
    label: "screens.dedicatedSpectralRadio.label",
    index: 0,
    video: dedicatedSpectralRadioMp4,
    poster: dedicatedSpectralRadioJpg,
    playbackTimeInSeconds: 4,
  },
  {
    id: 1,
    label: "screens.powerfulChannelPlanning.label",
    index: 1,
    video: powerfulChannelPlanningMp4,
    poster: powerfulChannelPlanningJpg,
    playbackTimeInSeconds: 6,
  },
  {
    id: 2,
    label: "screens.rfEnvironmentScanning.label",
    index: 2,
    video: rfEnvironmentScanningMp4,
    poster: rfEnvironmentScanningJpg,
    playbackTimeInSeconds: 3,
  },
  {
    id: 3,
    label: "screens.flexibleAuthMethods.label",
    index: 3,
    video: flexibleAuthMethodsMp4,
    poster: flexibleAuthMethodsJpg,
    playbackTimeInSeconds: 6,
  },
  {
    id: 4,
    label: "screens.centralizedRemoteManagement.label",
    index: 4,
    video: wifiCentralizedRemoteManagementMp4,
    poster: wifiCentralizedRemoteManagementJpg,
    playbackTimeInSeconds: 10,
  },
  {
    id: 5,
    label: "screens.apAnalyzer.label",
    index: 5,
    video: apAnalyzerMp4,
    poster: apAnalyzerJpg,
    playbackTimeInSeconds: 10,
  },
] satisfies IOverviewHeroSlide[];
